import { Product } from "./systemInfo.service";

export interface Agent
{
    AgentId: string;
    IsPrimary?: boolean;
    ReleaseStage: ReleaseStage;
    EnableClientBridge?: boolean;
    IsSupportAgent?: boolean;
    Description?: string;
}

export enum ReleaseStage
{
    Staging = "Staging",
    RC = "RC",
    Production = "Production",
    Tenanted = "Tenanted",
    Product = "Product"
}

export function foundryBaseUrls(tenant: string, product?: string): Record<ReleaseStage, string>
{
    return {
        [ReleaseStage.Staging]: "https://staging-ai-foundry.socrata-qa.com",
        [ReleaseStage.RC]: `https://${tenant}.rc-ai-foundry.socrata-qa.com`,
        [ReleaseStage.Production]: "https://foundry.tylertechai.com",
        [ReleaseStage.Tenanted]: `https://${tenant}.foundry.tylertechai.com`,
        [ReleaseStage.Product]: `https://${productTenants[product as Product]}.foundry.tylertechai.com`
    };
}

const productTenants: Readonly<Record<Product, string>> = {
    [Product.Incode9]: "erp-pro-nine",
    [Product.Incode10]: "erp-pro-ten",
    [Product.InfiniteVisions]: "sepro-support",
};
